module.exports = __webpack_public_path__ + "static/media/tagIcon.761e04a4.svg";